import { effectiveHotelPlannerSite, HotelPlannerSite, hotelPlannerHosts, toHotelPlannerSite } from "@eventr/common";
import { bs, BoundStore, useBoundStore } from "state/bound.store";
import { reactAppStage } from "utils/reactAppStage";

const selectHotelSite = (s: Pick<BoundStore, "orgConfig" | "selectedOrg">): HotelPlannerSite =>
  effectiveHotelPlannerSite(s.orgConfig?.hotelRewardsOnly, s.selectedOrg?.hotelRewardsOnly);

/** The site hotel requests use: the user's choice for the current org, else the org default. */
export const currentHotelSite = (): HotelPlannerSite => selectHotelSite(bs());

export const useHotelSite = (): HotelPlannerSite => useBoundStore(selectHotelSite);

/** Mobile host of the site a booking was made on. Bookings without a site are standard. */
export const hotelPlannerMobileHost = (site: unknown): string =>
  hotelPlannerHosts(toHotelPlannerSite(site), reactAppStage()).mobileHost;
